<template>
  <div class="about">
    <v-parallax height="400" :src="require('@/assets/meeting.jpg')">
      <h1 class="parallax-title"> Cuéntanos tus planes </h1>
    </v-parallax>
    <v-layout row wrap align-center class="mt-5 mb-5">
      <v-flex xs12 sm4 offset-sm1 class="">
        <v-card class="elevation-0 transparent">
          <v-card-title primary-title class="layout justify-center">
              <div><h1>Ponte en contacto con nosotros</h1></div>
          </v-card-title>
          <v-list class="transparent">
              <v-list-tile>
              <v-list-tile-action>
                  <v-icon color="primary">phone</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                  <v-list-tile-title>93 570 45 54 / 93 570 55 22</v-list-tile-title>
              </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
              <v-list-tile-action>
                  <v-icon color="primary">place</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                  <v-list-tile-title>Mollet del vallès, Catalunya, España</v-list-tile-title>
              </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
              <v-list-tile-action>
                  <v-icon color="primary">email</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                  <v-list-tile-title>mail@immobiliariacatalunya.cat</v-list-tile-title>
              </v-list-tile-content>
              </v-list-tile>
          </v-list>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d543.3948294250926!2d2.21357615589632!3d41.53899522009464!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a4bed7f58aa1f3%3A0x1fbade2752444018!2sImmobili%C3%A0ria+i+Serveis+Catalunya!5e0!3m2!1ses!2ses!4v1542580135168" width="100%" height="250" frameborder="0" style="border:0" allowfullscreen></iframe>
          </v-card>
      </v-flex>
      <v-flex md4 offset-md2 xs12 class="pl-5 pr-5 pb-5 pt-5 mt-5">
        <h1>Envianos un mensaje y hablemos!</h1>
        <v-form>
          <v-text-field
            v-model="email"
            label="E-mail"
            required
          ></v-text-field>
          <v-text-field
            v-model="subject"
            label="Asunto"
            required
          ></v-text-field>
          <v-text-field
            v-model="phone"
            label="Teléfono"
            required
          ></v-text-field>
          <v-textarea
            solo
            v-model="message"
            name="input-7-4"
            label="Cuerpo del email"
          ></v-textarea>
          <v-btn @click="sendEmail" block color="primary">Enviar</v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import ContactCard from '@/components/contactCard.vue'
import { API_URL } from '../constants'
import axios from 'axios'

export default {
  components : {
    ContactCard
  },
  data : () => {
    return {
      elevations :true,
      email: '',
      subject: '',
      phone: '',
      message: ''
    }
  },
  methods: {
    onResize () {
      var width = window.innerWidth;

      if (width < 400) {
        this.elevations = false
      } else {
        this.elevations = true;
      }
    },
    sendEmail() {
      axios.post(`${API_URL}/PublicProperties/Mail`, 
      {
        from: this.email,
        subject: this.subject,
        message: this.message,
        phone: this.phone
      }).then((response) => {
        alert("Mensaje recibido nos pondremos en contacto con usted a la mayor brevedad posible");
      });
    }
  }
}

</script>

<style scoped>

h1 {
  font-weight: lighter;
}

.parallax-title {
  font-size: 150px;
  font-weight: lighter;
}

@media (min-width: 324px) and (max-width: 1023px) {
  .parallax-title {
    font-size: 70px;
    font-weight: lighter;
  }
}

@media (min-width: 0px) and (max-width: 323px) {
  .parallax-title {
    font-size: 60px;
    font-weight: lighter;
  }
}

</style>
